// AOS
AOS.init({
  duration: 1000
});

// SmoothScroll
var scroll = new SmoothScroll('[data-scroll]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 20
});

if ($('main.post')[0]) {
  $this = $('main.post');
  right = parseInt($this.find('.hero-img-addon').css('right'), 10);
  if ($(window).width() > 960) {
    $(window).scroll(function() {
      $this.find('.hero-img')
        .css("opacity", 1 - $(window).scrollTop() / 800)
        .css("filter", "blur(" + ($(window).scrollTop() / 15) + "px)")
        .css("top", "-" + (0 + 100 * $(window).scrollTop() / 1500) + "%");
  
      $this.find('.hero-img-addon')
        .css("right", right - (0 + 100 * $(window).scrollTop() / 250) + "px");
    //  $('main.post .hero-info')
    //    .css("opacity", 1.25 - $(window).scrollTop() / 650)
    });
  }
}
